export default __webpack_public_path__ + "164a408310e9f3e1b463ddc7aa437df6.png";